import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  template: `<div>
  footer works!
</div>
`,
  styles: [`div{background-color:bisque;width:100%;min-height:200px}`]
})
export class FooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
